// Central Foresee route configuration — the single place to change the
// canonical marketing URL and the tracked enquiry/booking links. Page content
// itself lives in the CMS (cms_listings, slug "amden-foresee").
import { getEcosystemItems } from './ecosystem';

export const FORESEE_ROUTE = '/systems/foresee';
export const FORESEE_LISTING_SLUG = 'amden-foresee';

const TRACKING = 'interest=amden-foresee&source=Foresee%20Product%20Page';
export const FORESEE_DEMO_HREF = `/contact?${TRACKING}#book-appointment`;
export const FORESEE_PRICING_HREF = `/contact?${TRACKING}&topic=pricing#contact-enquiry`;

export const getForesee = () =>
  getEcosystemItems().find((it) => it.slug === FORESEE_LISTING_SLUG) || null;
